export default __webpack_public_path__ + "static/media/facebook.37a9cda7.svg";